import React, { useEffect, useRef, useState } from 'react';
import { ActionSheetContent } from '@/components/action-sheet';
import { TextInput as BaseTextInput, StyleSheet } from 'react-native';
import { SCREEN_PADDING } from '@/styles';
import { TextInput } from '@/components/text-input';

interface Props {
  action: string;
  initialName?: string;
  loading: boolean;
  onAction: (itemName: string) => void;
  title: string;
}

export const MenuItemNameContent: React.FC<Props> = ({
  action,
  initialName,
  loading,
  onAction,
  title,
}) => {
  const [itemName, setItemName] = useState(initialName || '');
  const inputRef = useRef<BaseTextInput>(null);

  // Manually invoke focus since Android does not
  // show keyboard when using autoFocus
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <ActionSheetContent
      actions={[action]}
      loadingActionIndex={loading ? 0 : undefined}
      message={
        <TextInput
          autoComplete="off"
          containerStyle={styles.input}
          inputRef={inputRef}
          onChangeText={setItemName}
          value={itemName}
        />
      }
      onAction={() => onAction(itemName)}
      title={title}
    />
  );
};

const styles = StyleSheet.create({
  input: {
    marginBottom: SCREEN_PADDING,
  },
});
